import { Box, Button, Modal } from "@mui/material";
import { ASSIGNABLE_ROLES, ROLE_LABELS, User, UserRoles } from "../../types";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Input } from "../../hookFormComponents.tsx/Input";
import { api } from "../../api/api";
import SelectM from "../../hookFormComponents.tsx/Select";

type Props = {
  modalConfig: { open: boolean; data: User };
  handleClose: () => void;
  fetcher: () => Promise<void>;
  setModalConfig: React.Dispatch<
    React.SetStateAction<
      | {
          data?: User;
          open: boolean;
        }
      | undefined
    >
  >;
};

function CreateModal({
  modalConfig,
  handleClose,
  fetcher,
  setModalConfig,
}: Props) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 600,
    bgcolor: "white",
    boxShadow: 24,
    borderRadius: "10px",
    p: 4,
  };

  const validationSchema1 = Yup.object({
    email: Yup.string().required("Required").email("Invalid Email"),
    password: Yup.string().required("Required").min(6, "Minumum 6 characters"),
    first_name: Yup.string().required("Required"),
    last_name: Yup.string().required("Required"),
    phone: Yup.number().required("Required"),
    role: Yup.string().required("Required"),
    max_bookings: Yup.number().required("Required"),
    username: Yup.string().required("Required"),
  });

  const validationSchema2 = Yup.object({
    email: Yup.string().required("Required").email("Invalid Email"),
    first_name: Yup.string().required("Required"),
    last_name: Yup.string().required("Required"),
    phone: Yup.number().required("Required"),
    role: Yup.string().required("Required"),
    max_bookings: Yup.number().required("Required"),
    username: Yup.string().required("Required"),
  });

  const {
    formState: { errors },
    control,
    setValue,
    register,
    handleSubmit,
    getValues,
    watch,
  } = useForm<
    Yup.InferType<typeof validationSchema1 | typeof validationSchema2>
  >({
    resolver: yupResolver(
      !modalConfig.data ? validationSchema1 : validationSchema2
    ),
    defaultValues: modalConfig.data
      ? {
          email: modalConfig.data.email,
          first_name: modalConfig.data.first_name,
          last_name: modalConfig.data.last_name,
          phone: modalConfig.data.phone,
          role: modalConfig.data.role ?? UserRoles.Employee,
          username: modalConfig.data.username,
          max_bookings: modalConfig.data.max_bookings,
        }
      : { role: UserRoles.Employee },
  });

  return (
    <Modal open={modalConfig.open} onClose={handleClose}>
      <Box sx={style}>
        <form
          noValidate
          onSubmit={handleSubmit((values) => {
            if (modalConfig.data) {
              api
                .post(`/users/${modalConfig.data.id}/update`, values)
                .then((res) => {
                  fetcher();
                  setModalConfig((prev) => ({
                    data: undefined,
                    open: false,
                  }));
                })
                .catch((e) => console.log(e));
            } else {
              api
                .post(`/auth/register`, values)
                .then((res) => {
                  fetcher();
                  setModalConfig((prev) => ({
                    data: undefined,
                    open: false,
                  }));
                })
                .catch((e) => console.log(e));
            }
          })}
        >
          <Input
            required
            {...register("email")}
            label={"Email"}
            type="text"
            error={errors?.email?.message}
          />
          {!modalConfig.data && (
            <Input
              required
              {...register("password")}
              label={"Password"}
              type="text"
              //@ts-ignore
              error={errors?.password?.message}
            />
          )}
          <Input
            required
            {...register("first_name")}
            label={"First name"}
            type="text"
            error={errors?.first_name?.message}
          />
          <Input
            required
            {...register("last_name")}
            label={"Last name"}
            type="text"
            error={errors?.last_name?.message}
          />
          <SelectM
            required
            label="Role"
            name="role"
            value={watch("role") ?? ""}
            setValue={setValue}
            errors={errors}
            options={ASSIGNABLE_ROLES.map((r) => ({ label: ROLE_LABELS[r], value: r }))}
          />
          <Input
            required
            {...register("username")}
            label={"Username"}
            type="text"
            error={errors?.username?.message}
          />
          <Input
            required
            {...register("phone")}
            label={"Phone"}
            type="text"
            error={errors?.phone?.message}
          />
          <Input
            required
            {...register("max_bookings")}
            label={"Max Bookings"}
            type="text"
            error={errors?.phone?.message}
          />
          <Box sx={{ display: "flex", justifyContent: "right" }}>
          <Button type="submit" variant="contained">
              Submit
            </Button>
          </Box>
        </form>
      </Box>
    </Modal>
  );
}

export default CreateModal;
